import React from "react";
import PropTypes from "prop-types";
import { AppBar, Box, Paper, Toolbar, Typography } from "@mui/material";
import ContentPanelScrollLayout from "./ContentPanelScrollLayout";
import {
  contentPanelBodyShellSx,
  contentSectionMenubarSx,
  contentSectionMenubarTitleSx,
  contentSectionMenubarToolbarSx,
  contentViewportSectionPaperSx,
} from "./contentEditorStyles";

const ContentSectionPanel = ({
  title,
  toolbar,
  children,
  fillBody = false,
  panelScroll = false,
  footer,
}) => {
  const usePanelScroll = !fillBody || panelScroll || Boolean(footer);

  return (
    <Paper elevation={0} sx={contentViewportSectionPaperSx}>
      <AppBar position="static" color="default" elevation={0} sx={contentSectionMenubarSx}>
        <Toolbar
          sx={{
            ...contentSectionMenubarToolbarSx,
            justifyContent: toolbar ? "space-between" : "flex-start",
          }}
        >
          <Typography component="h2" sx={contentSectionMenubarTitleSx}>
            {title}
          </Typography>
          {toolbar}
        </Toolbar>
      </AppBar>
      <Box sx={contentPanelBodyShellSx}>
        {usePanelScroll ? (
          <ContentPanelScrollLayout footer={footer}>{children}</ContentPanelScrollLayout>
        ) : (
          children
        )}
      </Box>
    </Paper>
  );
};

ContentSectionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  toolbar: PropTypes.node,
  children: PropTypes.node,
  fillBody: PropTypes.bool,
  panelScroll: PropTypes.bool,
  footer: PropTypes.node,
};

export default ContentSectionPanel;
